import { render, staticRenderFns } from "./PortfolioSearchSelect.vue?vue&type=template&id=53e2d529&scoped=true&"
import script from "./PortfolioSearchSelect.vue?vue&type=script&lang=js&"
export * from "./PortfolioSearchSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e2d529",
  null
  
)

export default component.exports